import ChevronLeftIcon from '@mui/icons-material/ChevronLeftRounded';
import {
  Box, Button, Typography,
} from '@mui/material';
import React from 'react';
import useHistory from '../Hooks/useHistory/useHistory';

interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export default function PageHeader(props: PageHeaderProps) {
  const { title, children } = props;
  const { goBack, hasHistory } = useHistory();

  return (
    <Box className="header">
      <div className="title">
        {hasHistory && (
          <Button onClick={() => { goBack(); }} className="nav-previous">
            <ChevronLeftIcon />
          </Button>
        )}
        <Typography variant="h1">{title}</Typography>
      </div>
      {children}
    </Box>
  );
}
